// 分类类型枚举
export const circleCateType = {
  circle: 1, // 圈子
  model: 2, // 模型
  tag: 3, // 标签
  product: 4, // 产品品
  faq: 5, // 常见问题(帮助中心)
  document: 6, // 说明文档
  modelV3: 7, // v3模型分类
  infor: 8 // 新闻资讯
}
// 分类状态值
export const comStatusType = {
  wait: 1, // 待上架 或者 待发布 等待处理
  up: 2, // 上架
  down: 3, // 下架
  delete: 4, // 删除
  draft: 5 // 草稿
}
// 用户账号状态
export const userStatusName = {
  all: 0, // 全部
  normal: 1, // 正常
  wait: 2, // 等待禁言生效中
  disable: 3, // 被禁言
  delete: 4, // 被封号
  logout: 5, // 已注销
  logoutApply: 6 // 注销申请
}
// 上下架列表
export const statusList = [
  { value: comStatusType.up, label: '上架' },
  { value: comStatusType.down, label: '下架' }
]

// 模型是否独家 枚举
export const MODEL_EXCLUSIVE_TYPE = {
  yes: 1,
  no: 2
}

// 常规boolean枚举
export const COMMON_BOOLEAN_TYPE = {
  YES: 1,
  NO: 2
}

export const rewardType = {
  // 经验值
  experience: 1,
  // 酷维豆
  kuweiBean: 2
}
// 标签分类类型
export const tagsCateType = {
  content: '38', // 帖子标签
  model: '37', // 模型标签
  circle: '36', // 圈子标签
  device: '59', // 机型标签
  qr: '309' // 机型标签
}
// 公告类型枚举
export const noticeTypeName = {
  all: 0, // 全部
  bulletinMessage: 1, // 公告消息
  activeMessage: 2 // 活动消息
}

// 小工具付费方式
export const exchangeTypeEnum = {
  // 免费
  free: 1,
  // vip专享
  vip: 2,
  // 酷维豆付费
  kwbeans: 3,
  // 创想币付费
  creatBeans: 4
}

// 活动进行状态
export const activity_status = {
  // 待开始
  waitStart: 1,
  // 进行中
  pending: 2,
  // 已结束
  end: 3
}
// 公告状态枚举
export const noticeStatusName = {
  all: 0, // 全部
  wait: 1, // 待发送
  post: 2, // 已送达
  recall: 5, // 已撤回
  succ: 3, // 进行中
  due: 4 // 已到期
}
export const sourceName = {
  // 来源 枚举
  all: 0,
  user: 1, // 用户
  oficial: 2 // 官方
}
export const statusName = {
  // 状态 枚举
  all: 0, // 全部
  wait: 1, // 待审核
  pass: 2, // 审核通过、上架、启用
  noPass: 3, // 不通过、下架、禁用
  del: 4, // 删除
  waitPush: 5 // 代发布、草稿
}
export const modelGroupstatusName = {
  all: 0, // 全部
  wait: 1, // 待审核
  up: 2, // 上架
  down: 4, // 下架
  noPass: 3, // 不通过
  del: 5, // 模型被删除
  waitDeel: 6, // 处理中
  sliceTesting: 7, // 云切片预检测中
  preCheck3mfFail: 8 // 云切片预检测失败
}

// 模型机型状态  1. 待机审 2. 机审通过 3. 机审可疑 4. 机审不通过 5. 复审通过 6. 复审不通过
export const MODEL_MACHINE_REVIEW_STATUS = {
  wait: 1,
  pass: 2,
  dubious: 3,
  noPass: 4,
  reviewPassed: 5,
  reviewFailed: 6
}

export const MACHINE_REVIEW_STATUS_LIST = [
  {
    label: '待机审',
    value: MODEL_MACHINE_REVIEW_STATUS.wait
  },
  {
    label: '机审通过',
    value: MODEL_MACHINE_REVIEW_STATUS.pass
  },
  {
    label: '机审可疑',
    value: MODEL_MACHINE_REVIEW_STATUS.dubious
  },
  {
    label: '机审不通过',
    value: MODEL_MACHINE_REVIEW_STATUS.noPass
  },
  {
    label: '复审通过',
    value: MODEL_MACHINE_REVIEW_STATUS.reviewPassed
  },
  {
    label: '复审不通过',
    value: MODEL_MACHINE_REVIEW_STATUS.reviewFailed
  }
]

// 多语言数据源，后续下面有需要的数据结构，都已这个为基准去创建，方便后期小语种的删减
const langBase = {
  en: { value: 0, name: '英语' },
  zh: { value: 1, name: '中文' },
  ft: { value: 2, name: '繁体' },
  ru: { value: 4, name: '俄语' },
  ko: { value: 5, name: '韩语' },
  ar: { value: 6, name: '阿拉伯语' },
  es: { value: 7, name: '西班牙语' },
  de: { value: 8, name: '德语' },
  fr: { value: 9, name: '法语' },
  jp: { value: 10, name: '日语' },
  pt: { value: 11, name: '葡语' },
  th: { value: 12, name: '泰语' },
  nl: { value: 13, name: '荷兰' },
  it: { value: 14, name: '意大利语' },
  br: { value: 15, name: '葡萄牙语-巴西' },
  tr: { value: 16, name: '土耳其语' },
  ro: { value: 17, name: '罗马尼亚语' },
  he: { value: 18, name: '希伯来语' }
}

// 智能翻译多语言枚举  根据产品要求按照原型图来的
export const AI_TRANSLATION_LANG = [
  { value: 0, name: '英文' },
  { value: 4, name: '俄罗斯' },
  { value: 5, name: '韩语' },
  { value: 6, name: '阿拉伯' },
  { value: 7, name: '西班牙' },
  { value: 8, name: '德语' },
  { value: 9, name: '法语' },
  { value: 10, name: '日语' },
  { value: 11, name: '葡萄牙' },
  { value: 13, name: '荷兰' },
  { value: 14, name: '意大利' },
  { value: 16, name: '土耳其' },
  { value: 17, name: '罗马尼亚' }
]

// 数据格式为 { en: 0,  zh: 1, ft: 2 }
const langListFn = () => {
  const _langList = {}
  let k
  for (k in langBase) {
    _langList[k] = langBase[k].value
  }
  return _langList
}
export const langList = langListFn()
// 数据格式为 { 0: '英文',  1: '中文', 2: '繁体' }
const langTextFn = () => {
  let _langText = {}
  let k
  for (k in langBase) {
    const lang = langBase[k]
    _langText[lang.value] = lang.name
  }
  return _langText
}
export const langText = langTextFn()
// 数据格式为 [ { value: 0, name: '英文', iso: 'en' } ]
const langListObjectFn = () => {
  let _langListObject = []
  let k
  for (k in langBase) {
    const temp = {}
    temp.iso = k
    temp.value = langBase[k].value
    temp.name = langBase[k].name
    _langListObject.push(temp)
  }
  return _langListObject
}
export const langListObject = langListObjectFn()
// 公共多语言枚举 数据格式为 [ { value: 0, name: '英文' } ]
const langComFn = () => {
  let langCom = []
  let k
  for (k in langBase) {
    const { value, name } = langBase[k]
    const temp = {}
    if (value !== 0 && value !== 1) {
      temp.value = value
      temp.name = name
      langCom.push(temp)
    }
  }
  return langCom
}
export const langCom = langComFn()
// 国内多语言枚举
export const langZh = [
  {
    value: langBase.zh.value,
    name: langBase.zh.name
  },
  {
    value: langBase.en.value,
    name: langBase.en.name
  },
  ...langCom
]
// 国外多语言枚举
export const langEn = [
  {
    value: langBase.en.value,
    name: langBase.en.name
  },
  {
    value: langBase.zh.value,
    name: langBase.zh.name
  },
  ...langCom
]

export const MODULE_ID = {
  // 操作记录模块
  user: 1, // 用户
  circle: 2, // 圈子
  post: 3, // 帖子
  model: 4, // 模型
  bulletin: 5, // 公告
  activity: 6, // 活动
  content: 7, // 内容置顶
  account: 8, // 账号删除相关
  tag: 9, // 标签相关
  member: 10, // 会员相关
  comment: 11, // 评论管理
  print: 12, // 打印机管理
  software: 13, // 软固件管理
  withdraw: 14, // 提现
  externalLinks: 15, // 外链管理
  // 内容合辑
  contentCollcetion: 16,
  // 切片参数公共模板修改
  sliceParamsChange: 17,
  // 风控管理
  riskManage: 18,
  // 19 专题模块
  thematic: 19,
  // 20 创想币
  crealityCoin: 20,
  // 新公共切片参数
  newComSlice: 22,
  // 光固化层厚
  dlpSliceManage: 23,
  // IP风控
  ipRisk: 25,
  // 兑换商城
  eshop: 1001,
  // 1002 现金激励
  cashIncentive: 1002,
  // 1003 抽奖
  lottery: 1003
}

export const MODULE_ID_LIST = Object.entries(MODULE_ID).map(([key, value]) => ({
  label:
    {
      user: '用户',
      circle: '圈子',
      post: '帖子',
      model: '模型',
      bulletin: '公告',
      activity: '活动',
      content: '内容置顶',
      account: '账号删除',
      tag: '标签',
      member: '会员',
      comment: '评论管理',
      print: '打印机管理',
      software: '软固件管理',
      externalLinks: '外链管理',
      withdraw: '提现',
      contentCollcetion: '内容合辑',
      sliceParamsChange: '切片参数模板',
      crealityCoin: '创想币模块',
      riskManage: '风控管理',
      thematic: '专题',
      newComSlice: '新公共切片参数',
      dlpSliceManage: '光固化层厚',
      ipRisk: 'IP风控',
      eshop: '兑换商城',
      cashIncentive: '现金激励',
      lottery: '抽奖'
    }[key] || key,
  value
}))

export const gradeList = [
  {
    label: '请选择',
    value: 0
  },
  {
    label: '零级',
    value: 1
  },
  {
    label: '一级',
    value: 2
  },
  {
    label: '二级',
    value: 3
  },
  {
    label: '三级',
    value: 4
  },
  {
    label: '四级',
    value: 5
  },
  {
    label: '五级',
    value: 6
  }
]

// 标签条件
export const tagConditionList = [
  {
    label: '所有',
    value: 0
  },
  {
    label: '有标签',
    value: 1
  },
  {
    label: '有置顶标签',
    value: 2
  }
]

// 模型是否推荐的 操作
export const MODEL_RECOMMEND_STATUS = {
  // 推荐-待确认状态
  confirmed: 1,
  // 以推荐-确认状态
  confirm: 2,
  // 禁止推荐
  forbid: 3,
  // 取消推荐
  cancel: 4,
  // 取消禁止推荐
  cancelForbid: 5
}

export const MODEL_RECOMMEND_LIST = [
  {
    label: '全部',
    value: 0
  },
  {
    label: '待确认',
    value: MODEL_RECOMMEND_STATUS.confirmed
  },
  {
    label: '已推荐',
    value: MODEL_RECOMMEND_STATUS.confirm
  },
  {
    label: '禁止推荐',
    value: MODEL_RECOMMEND_STATUS.forbid
  }
]

// 经验值，任务类型枚举
export const TASK_TYPE = {
  Novice: 1, // 新手任务
  daily: 2, // 日常任务
  activity: 3, // 活动任务
  welfare: 4, // 福利任务
  member: 5 // 会员任务
}

// 任务条件枚举
export const taskRuleIdRnum = {
  // 签到
  sign: 1,
  // 关注
  like: 10,
  // 用户其他资料
  userOtherDesc: 15,
  // 浏览内容
  viewContent: 58,
  // 搜索内容
  searchContent: 59,
  // 浏览活动赛事
  viewActive: 60,
  // 评论内容
  commentContent: 61,
  // 评论模型
  commentModel: 62,
  // 浏览3D百科资讯
  taskRuleBrowse3DWiki: 77,
  // 浏览指定模型
  taskSpecifiedModelBrowse: 79,
  // 浏览模型专题(配h5)
  taskSubjectBrowse: 80,
  // 浏览促销模型
  taskPromoModelBrowse: 81,
  // 设置促销模型
  taskSetPromoModel: 82,
  // 指定模型上传实拍且关联打印文件
  assignModelLive: 87,
  // 上传Cube模型
  cubeme: 93,
  // 编辑个人简介
  editUserIntro: 94,
  // 文字评论模型
  commontModelText: 95,
  // 文字带图评论模型
  commontModelWithImg: 96,
  // 学习新手打印教程
  tutorialPrint: 102
}

// 经验值，任务类型枚举
export const TASK_TYPE_LIST = [
  {
    id: TASK_TYPE.Novice,
    label: '新手任务'
  },
  {
    id: TASK_TYPE.daily,
    label: '日常任务'
  },
  {
    id: TASK_TYPE.activity,
    label: '活动任务'
  },
  {
    id: TASK_TYPE.welfare,
    label: '福利任务'
  },
  {
    id: TASK_TYPE.member,
    label: '会员任务'
  }
]

// 经验值，任务状态
export const TASK_STATUS_TYPE = {
  wait: 1, // 待开始
  onShelf: 2, // 上架
  offShelf: 3, // 下架
  del: 4 // 删除
}

// 经验值，任务状态列表
export const TASK_STATUS_LIST = [
  {
    id: TASK_STATUS_TYPE.wait,
    label: '待开始'
  },
  {
    id: TASK_STATUS_TYPE.onShelf,
    label: '上架中'
  },
  {
    id: TASK_STATUS_TYPE.offShelf,
    label: '已下架'
  },
  {
    id: TASK_STATUS_TYPE.del,
    label: '已删除'
  }
]

// 设备类型枚举
export const BOX_TYPE_ENUM = {
  wifi: 1, // wifi盒子
  bluetooth: 2, // 蓝牙盒子
  fdm: 3, // FDM打印机
  ld: 4, // 光固化打印机
  shumei: 5, // 树莓派
  laserCutter: 6, // 雕刻机
  wisdomScreen: 7, // 智慧屏
  // 音速屏
  sonicScreen: 8,
  // fdm高速机
  fdmHighSpeed: 9,
  // 星云屏
  xingYunPing: 10,
  // 干燥盒
  dryBox: 11,
  // FDM 创想品牌
  crealityFdm: 12,
  // FDM SPARKX品牌
  crealitySparkx: 13,
  // M1生成器
  m1: 14
}

// 盒子支持 双向RPC的版本
export const BOX_TWO_RPC_VER = 'V3.01b54'
// K1高速机支持双向RPC的版本
export const K1_TWO_RPC_VER = '1.2.0.3'
// 光固化支持双向RPC的版本
export const LINGT_TWO_RPC_VER = 'V2.241.12'

// 设备类型列表
export const BOX_TYPE_LIST = [
  {
    id: BOX_TYPE_ENUM.dryBox,
    label: '耗材干燥盒'
  },
  {
    id: BOX_TYPE_ENUM.wifi,
    // label: 'wifi盒子'
    // label: '创想盒子'
    label: '创想盒子(WiFi 添加)'
  },
  {
    id: BOX_TYPE_ENUM.bluetooth,
    // label: '蓝牙盒子'
    // label: '创想盒子2.0'
    label: '创想盒子2.0(WiFi/蓝牙添加)'
  },
  {
    id: BOX_TYPE_ENUM.fdm,
    // label: 'FDM打印机'
    label: 'FDM普通打印机(PIN码添加)'
  },
  {
    id: BOX_TYPE_ENUM.ld,
    // label: '光固化打印机'
    label: '光固化打印机(扫码添加)'
  },
  {
    id: BOX_TYPE_ENUM.shumei,
    // label: '树莓派'
    label: '树莓派(WiFi/蓝牙添加)'
  },
  {
    id: BOX_TYPE_ENUM.laserCutter,
    // label: '雕刻机'
    label: '雕刻机(蓝牙添加)'
  },
  {
    id: BOX_TYPE_ENUM.wisdomScreen,
    label: '智慧屏'
  },
  {
    id: BOX_TYPE_ENUM.sonicScreen,
    // label: '音速屏'
    label: '音速屏(屏端登录)'
  },
  {
    id: BOX_TYPE_ENUM.fdmHighSpeed,
    // label: 'FDM(高速打印机)'
    label: 'FDM高速打印机(扫码添加)'
  },
  {
    id: BOX_TYPE_ENUM.xingYunPing,
    // label: '星云屏'
    label: '星云屏(扫码添加)'
  },
  {
    id: BOX_TYPE_ENUM.m1,
    label: 'M1生成器'
  }
]
// 奖励类型
export const REWARD_TYPE = {
  // 库维豆
  bean: 2,
  // 经验值
  express: 1
}
// 原创协议列表
export const ORIGINAL_LIST = [
  { value: 'CC BY', label: 'CC BY' },
  { value: 'CC BY-SA', label: 'CC BY-SA' },
  { value: 'CC BY-NC', label: 'CC BY-NC' },
  { value: 'CC BY-NC-SA', label: 'CC BY-NC-SA' },
  { value: 'CC BY-ND', label: 'CC BY-ND' },
  { value: 'CC BY-NC-ND', label: 'CC BY-NC-ND' },
  { value: 'CC0', label: 'CC0' }
]
// 素材玩法类型
export const PLAY_ENUM = {
  globe: 1, // 球体
  pic: 2, // 贴图
  text: 3, // 贴字
  footer: 4, // 底座
  border: 5, // 装饰边框
  // 款式
  styles: 6,
  // 相框
  frame: 7
}
// 小工具类型枚举
export const WIDGET_ENUM = {
  light: 1, // 星球灯
  pic: 2, // 3d照片
  wish: 3, // 心愿单
  laser: 4, // 雕刻机，
  licensePlate: 5, // 挪车牌
  penContainer: 6, // 笔筒
  // 拍照建模
  photoModel: 7
}
// 机型系列类型枚举
export const printerSeriesType = {
  // fdm
  fdm: 1,
  // 光固化
  access: 2,
  // 干燥盒
  dryBox: 3,
  // 雕刻机
  laster: 9,
  // M1生成器
  m1: 10
}
// 频道显示位置枚举
export const channelLocation = {
  printSchool: 1, // 趣打印 -小课堂
  printHot: 2, // 趣打印-交流热区
  play: 3 // 玩社区
}
// 内容类型
export const contentType = {
  // 频道
  channel: 1,
  // 圈子
  circle: 2,
  // 小工具
  tool: 3,
  // 广场
  plaza: 4
}

// 内容状态
export const contentStatus = {
  // 1-待审核
  pending: 1,
  // 2-审核通过
  suc: 2,
  // 3-审核失败
  fail: 3,
  // 4-下架、删除
  delete: 4,
  // 5-草稿
  draft: 5
}

// 内容形式枚举
export const postTypeEnum = {
  short: 1, // 图文并排
  long: 2 // 长图文
}
// 媒体类型
export const mediaTypeEnum = {
  // 纯文本
  text: 1,
  // 图片
  pic: 2,
  // 视频
  video: 3,
  // 长图文
  longPic: 4
}
// 性别枚举
export const sexEnum = {
  secrecy: 0, // 保密
  woman: 1, // 女
  man: 2 // 男
}
// 机器人任务类别
export const subjectTypeEnum = {
  all: 0, // 全部
  model: 1, // 模型
  post: 2, // 帖子
  user: 6, // 用户
  comment: 7 // 评论
}
// 机器人任务行为
export const robotActionEnum = {
  all: 0, // 全部
  like: 6, // 点赞
  collect: 7, // 收藏
  recommend: 8, // 评论
  follow: 10 // 关注
}
// app 使用情况枚举
export const appUseEnum = {
  // 正常使用（3天内登陆）
  normal: 1,
  // 长时间未登录
  notUse: 2
}
export const configType = {
  // 地址白名单
  whiteLink: 1,
  // 树莓派教程
  shumei: 2,
  // 模型举报
  modelReport: 3,
  // 内容举报
  contentReport: 4,
  // 评论举报
  commentReport: 5,
  // 用户举报
  userReport: 6,
  // 模型及切片数量
  modelNum: 7,
  // 模型及切片大小
  modelSize: 8,
  // 图片上传数量
  picNum: 9,
  // 意见反馈跳转频道
  feedBackLink: 10,
  // 邀请有你开关
  invited: 11,
  // 切片保存的机型记录数量
  sliceRecordNum: 14,
  // 切片保存的参数数量限制
  sliceParamsNum: 15,
  // 小工具分类
  widgetCategory: 16,
  // 树莓派教程v2
  raspberryV2: 17,
  // 设备配网
  deviceTutorial: 18,
  // 设备
  device: 19,
  // 广场频道
  squareChannel: 20,
  // 存在设备时
  deviceFull: 21,
  // 帮助中心
  memberHelp: 22,
  // 模型审核
  reviewModel: 23,
  // 提现创想币汇率
  withdrawal: 24,
  // 切片配置
  sliceSet: 25,
  // 意见反馈标签
  feedBackTag: 26,
  // 打印服务
  printServe: 27,
  // 模型库关联标签类型
  modelTag: 28,
  // 创想币兑换商品（虚拟）
  coinExchangeGoods: 29,
  // 礼包配置
  gift: 30,
  // qr产品分类关联
  qrClass: 31,
  // 牌照建模免费次数
  photoModel: 32,
  // 内容合辑教程
  contentCollcetionDoc: 33,
  // kol提现标准
  kolSettle: 34,
  // 3D照片推广分销
  photo3d: 35,
  // 系统维护
  sysMaintain: 36,
  // 评分维度
  scoreDimension: 37,
  // 打印服务首单0元活动时间
  printActive: 38,
  // 任务中心图标显示时间
  taskShowTime: 39,
  // vip抽奖
  vipLottery: 40,
  // vip专区和促销专区 开关
  vipSwitch: 42,
  // 新手引导教程
  tiroLead: 43,
  // 国家税号
  taxNum: 44,
  // 工作台空状态
  workData: 45,
  // 首页广告展示位置
  homeShowcase: 46,
  // 推荐分流规则
  recommendedTraffic: 47,
  // 付费模型解锁要求
  paidModelUnlock: 48,
  // 新社区分流比例
  newCommunityTraffic: 50,
  // 星标模型官方留言配置
  starModelOfficial: 51
}
// 圈子类型
export const circleType = {
  // 普通圈子
  normal: 0,
  // 光固化圈子
  light: 1
}
// 栏目内容类型
export const contentTypeEnum = {
  // 产品
  product: 1,
  // 内容
  content: 2,
  // 模型
  model: 3,
  // 文件
  file: 4,
  // 文档
  document: 5
}
export const softTypeEnum = {
  // 文案类型枚举
  all: 0, // 全部
  hezi: 1, // 盒子固件
  // model: 2, // 打印机固件
  printer: 2, // 打印机固件
  // circle: 3, // 迪文屏固件
  diwenpin: 3, // 迪文屏固件
  // post: 4, // IPC摄像头固件
  ipcCamera: 4, // IPC摄像头固件
  // gcode: 5, // 树莓派固件
  shumeipi: 5, // 树莓派固件
  soft: 6, // 软件光固化
  softFdm: 7, // 软件 fdm
  crealitySlicer: 8, // Creality Slicer
  sliceSoftware: 9, // 大型机切片软件
  adWord: 10, // 广告字切片软件
  crStudio: 11, // CR Studio
  cura: 12, // 开源插件-Cura
  plugOctoprint: 13, // 开源插件-Octoprint
  raspberryPi: 14, // CrealityPi
  octoprint: 15, // Octoprint plugin
  laserCutter: 16, // 雕刻机
  piocreatBox: 17, // PiocreatBox三帝光固化切片软件
  // bltouch固件
  bltouch: 18,
  // crtouch固件
  crtouch: 19,
  // Creality 3D Pad固件
  creality3dPad: 20,
  // 音速屏
  sonicScreen: 21,
  // fdm快速打印机
  fdmSpeedPrint: 22,
  // creality scan
  crealityScan: 23,
  // 星云屏
  nebulaScreen: 24,
  // 模型组上传工具
  modelTool: 25,
  // CR-Scan/3D 扫描仪
  crScan3D: 26,
  // CFS料盒固件
  cfs: 27,
  // 激光雕刻机软件
  laserSoft: 28,
  // 创想助手软件
  crealityAssistant: 29,
  // M1
  M1: 30,
  // 耗材干燥盒
  dryBox: 31
}
// 切片类型枚举
export const sliceTypeEnum = {
  all: 0,
  fdm: 1,
  dlp: 2,
  cbd: 3
}
// 模型类型
export const modelType = {
  // 普通模型
  normal: 1,
  // 3D照片
  pic: 2,
  // T站
  tSite: 3,
  // 星球灯
  star: 4,
  licensePlate: 5, // 挪车牌
  penContainer: 6, // 笔筒
  // 国内/国际站导入
  import: 7,
  // 拍照建模
  photo: 8,
  makenow: 9 // makenow
}
export const modelTypeList = [
  {
    label: '普通模型',
    value: modelType.normal
  },
  {
    label: '3D照片模型',
    value: modelType.pic
  },
  {
    label: 'T站导入模型',
    value: modelType.tSite
  },
  {
    label: '星球灯',
    value: modelType.star
  },
  {
    label: '挪车牌',
    value: modelType.licensePlate
  },
  {
    label: '笔筒',
    value: modelType.penContainer
  },
  {
    label: '国内/国际站导入',
    value: modelType.import
  },
  {
    label: '拍照建模',
    value: modelType.photo
  },
  {
    label: 'makenow',
    value: modelType.makenow
  }
]

// 模型版权
export const MODEL_COPYRIGHT_TYPE = {
  // 正版版权
  LEGALCOPY: 1,
  // 盗版
  PIRATE: 2,
  // 申诉
  APPEAL: 3,
  // 重复模型
  ALLEGEDCOPY: 4
}

// 重复模型
export const ALLEGEDCOPY_SEARCH_OBJ = {
  ALL: 0,
  YES: 1,
  NO: 2
}
// 重复模型搜索列表
export const ALLEGEDCOPY_SEARCH_LIST = [
  {
    label: '全部',
    value: ALLEGEDCOPY_SEARCH_OBJ.ALL
  },
  {
    label: '是',
    value: ALLEGEDCOPY_SEARCH_OBJ.YES
  },
  {
    label: '否',
    value: ALLEGEDCOPY_SEARCH_OBJ.NO
  }
]

// 注册来源枚举
export const userPlatformType = {
  // IOS
  ios: 0,
  // 安卓
  android: 1,
  // PC_WEB
  webPc: 2,
  // PC_ADMIN
  adminPc: 3,
  // WAP
  wap: 4,
  // 光固化打印机
  printer: 5,
  // 切片软件
  slicer: 6,
  // 扫描仪
  scaner: 7,
  // FDM打印机（盒子）
  wifiBox: 8,
  // 树莓派
  raspberryPi: 9,
  // FDM一体机（新款）
  fdmPrinter: 10,
  // Creality Print 切片软件  FDM切片软件
  crealityPrint: 11,
  // Halot Box 光固化切片软件
  halotBox: 12,
  // Creality Slicer 切片软件  FDM切片软件
  crealitySlicer: 13,
  // Cura插件
  cura: 14,
  // 建模软件-web
  webModelingSoftware: 15,
  // 建模软件-桌面
  desktopModelingSoftware: 16,
  //  音速屏
  sonicScreen: 17,
  // IOS 极速版
  iosLite: 18,
  // 安卓 极速版
  androidLite: 19,
  // 桌面端上传工具
  desktopUploadTool: 20,
  // 光固化切片软件
  dlpSlicer: 21,
  // 其他
  other: -1,
  // 全部
  all: -2,
  // 未知
  unknown: 100000,
  // 干燥盒
  drybox: 22,
  // 鸿蒙
  HarmonyOS: 23,
  // F038-APP-ANDROID
  f038AppAndroid: 24,
  // F038-APP-IOS
  f038AppIos: 25
}
export const baseUserplatformList = [
  {
    label: 'iOS',
    value: userPlatformType.ios
  },
  {
    label: '安卓',
    value: userPlatformType.android
  },
  {
    label: 'PC前台',
    value: userPlatformType.webPc
  },
  {
    label: 'PC后台',
    value: userPlatformType.adminPc
  },
  {
    label: 'WAP端',
    value: userPlatformType.wap
  },
  {
    label: '光固化打印机',
    value: userPlatformType.printer
  },
  {
    label: '切片软件',
    value: userPlatformType.slicer
  },
  {
    label: '扫描仪',
    value: userPlatformType.scaner
  },
  {
    label: 'FDM打印机（盒子）',
    value: userPlatformType.wifiBox
  },
  {
    label: '树莓派',
    value: userPlatformType.raspberryPi
  },
  {
    label: 'FDM一体机（新款）',
    value: userPlatformType.fdmPrinter
  },
  {
    label: 'Creality Print 切片软件',
    value: userPlatformType.crealityPrint
  },
  {
    label: 'Halot Box 光固化切片软件',
    value: userPlatformType.halotBox
  },
  {
    label: 'Creality Slicer 切片软件',
    value: userPlatformType.crealitySlicer
  },
  {
    label: 'Cura插件',
    value: userPlatformType.cura
  },
  {
    label: '建模软件-web',
    value: userPlatformType.webModelingSoftware
  },
  {
    label: '建模软件-桌面',
    value: userPlatformType.desktopModelingSoftware
  },
  {
    label: '音速屏',
    value: userPlatformType.sonicScreen
  },
  {
    label: 'iOS-极速版/新',
    value: userPlatformType.iosLite
  },
  {
    label: 'android-极速版/新',
    value: userPlatformType.androidLite
  },
  {
    label: '桌面端上传工具',
    value: userPlatformType.desktopUploadTool
  },
  {
    label: '光固化切片软件',
    value: userPlatformType.dlpSlicer
  },
  {
    label: '其他',
    value: userPlatformType.other
  },
  {
    label: '未知',
    value: userPlatformType.unknown
  },
  {
    label: '干燥盒',
    value: userPlatformType.drybox
  },
  {
    label: '鸿蒙',
    value: userPlatformType.HarmonyOS
  },
  {
    label: 'F038-安卓',
    value: userPlatformType.f038AppAndroid
  },
  {
    label: 'F038-IOS',
    value: userPlatformType.f038AppIos
  }
]
// 注册来源枚举对应文案
export const userplatformList = [
  {
    label: '全部',
    value: userPlatformType.all
  },
  ...baseUserplatformList
]

export const userPlatformTypeList1 = [
  // {
  //   label: 'iOS',
  //   value: userPlatformType.ios
  // },
  // {
  //   label: 'android',
  //   value: userPlatformType.android
  // },
  // {
  //   label: 'Web端',
  //   value: userPlatformType.webPc
  // },
  // {
  //   label: 'H5端',
  //   value: userPlatformType.wap
  // },
  {
    label: 'iOS-极速版',
    value: userPlatformType.iosLite
  },
  {
    label: 'android-极速版',
    value: userPlatformType.androidLite
  }
]

export const userPlatformTypeList = [
  {
    label: '创想云（App完整版）',
    groupKey: 'appFull',
    value: [
      userPlatformType.ios,
      userPlatformType.android,
      userPlatformType.newAndroid,
      userPlatformType.newIos
    ]
  },
  {
    label: '创想云（App极速版）',
    groupKey: 'appLite',
    value: [userPlatformType.androidLite, userPlatformType.iosLite]
  },
  {
    label: '创想云（Web端）',
    groupKey: 'web',
    value: [userPlatformType.webPc]
  }
]

export const androidNoticeTypeList = [
  {
    label: '互动消息',
    value: 'social'
  },
  {
    label: '推荐内容',
    value: 'recommend'
  },
  {
    label: '活动',
    value: 'active'
  },
  {
    label: '账号',
    value: 'account'
  },
  {
    label: '模型',
    value: 'model'
  },
  {
    label: '内容',
    value: 'content'
  },
  {
    label: 'vip',
    value: 'vip'
  },
  {
    label: '酷维豆',
    value: 'cuvacoins'
  },
  {
    label: '创想币',
    value: 'credits'
  },
  {
    label: '设备',
    value: 'device'
  },
  {
    label: '订单',
    value: 'order'
  },
  {
    label: '其他',
    value: 'other'
  }
]

// 用户操作行为枚举
export const userStatusAction = {
  // 用户操作行为枚举
  ban: 1, // 封号
  banPost: 2, // 禁言
  recommend: 3, // 推荐
  cancelRecommend: 4, // 取消推荐
  rank: 5, // 编辑排序
  // 取消封号
  cancelBan: 6,
  // 取消禁言
  cancelBanPost: 7
}
// 禁言范围枚举（枚举值为掩码值，接口以整数数组传递）
export const muteTypeEnum = {
  all: 32, // 全部
  sendMsg: 1, // 发私信
  uploadModel: 8, // 上传模型
  publishContent: 16, // 发布内容
  modelComment: 2, // 模型评论
  communityComment: 4 // 社区评论
}
// 禁言范围选项
export const muteTypeList = [
  {
    label: '发私信',
    value: muteTypeEnum.sendMsg
  },
  {
    label: '上传模型',
    value: muteTypeEnum.uploadModel
  },
  {
    label: '发布内容',
    value: muteTypeEnum.publishContent
  },
  {
    label: '模型评论',
    value: muteTypeEnum.modelComment
  },
  {
    label: '社区评论',
    value: muteTypeEnum.communityComment
  }
]
// 活动平台类型枚举
export const platformsTypeEnmu = {
  app: 1,
  web: 2,
  h5: 3
}
// 活动身份枚举
export const activeIdentityEnum = {
  // 我司员工
  staff: 1,
  // 一级代理商
  firstAgent: 2,
  // 二级代理商
  secondAgent: 3,
  // 终端用户
  endUser: 4
}
// 模型出售方式
export const saleWayEnum = {
  // 免费
  free: 0,
  // 批量定价
  all: 1,
  // 单个定价
  item: 2
}
// 支付方式
export const payMethodEnum = {
  // 酷维豆
  bean: 1,
  // 创想币
  cxb: 2,
  // 礼包赠送
  gift: 9,
  // 现金
  money: 7
}
// 订单类型
export const orderTypeEnum = {
  // 收费订单
  pay: 1,
  // 赠送订单
  free: 2
}
export const orderPromoEnum = {
  // 无优惠
  no: 1,
  // 折扣
  off: 2,
  // 立减
  dis: 3,
  // 优惠券
  coupon: 4
}
export const orderTableEnum = {
  // 折扣
  off: 1,
  // 立减
  dis: 2
}
// 是否是建模师
export const isModelerEnum = {
  // 是
  yes: 1,
  // 否
  no: 2
}
// 支付状态
export const modelPayStatusEnum = {
  // 待支付
  wait: 1,
  // 支付成功
  succ: 2,
  // 支付失败
  fail: 3,
  // 取消失败
  false: 4,
  // 订单关闭/已退款
  close: 5
}
// 订阅方式  	枚举: 1,2 枚举备注: 1-普通订阅 2-连续订阅
export const subscribeTypeEnum = {
  // 普通订阅
  normal: 1,
  // 连续订阅
  continuous: 2
}

export const subscriptionTypeList = [
  {
    value: subscribeTypeEnum.normal,
    label: '普通订阅'
  },
  {
    value: subscribeTypeEnum.continuous,
    label: '连续订阅'
  }
]

// 切片耗材参数
export const sliceMaterialEnum = {
  pla: '1',
  abs: '2'
}
// 切片质量参数（层高）
export const sliceQualityEnum = {
  // 高精度
  hight: 1,
  // 普通
  normal: 2,
  // 快速
  quick: 3
}
// 光固化皮肤管理状态枚举
export const skinStatusEnum = Object.freeze({
  // 上架
  onShelf: 2,
  // 下架
  offShelf: 3
})

// 计费方式枚举
export const chargeTypeEnum = {
  // 其他，兼容之前的数据（按时间分配的）
  other: 0,
  // 一天
  day1: 5,
  // 三天
  day3: 6,
  // 周
  week: 7,
  // 月份
  month: 1,
  // 季度
  quarter: 2,
  // 半年
  yearHalf: 4,
  // 年
  year: 3,
  // 连续包月
  continuMonth: 8,
  // 连续包季
  continuQuarter: 9,
  // 连续包年
  continuYear: 10
}

export const CHARGE_TYPE_LIST = [
  {
    value: chargeTypeEnum.day1,
    name: '1天'
  },
  {
    value: chargeTypeEnum.day3,
    name: '3天'
  },
  {
    value: chargeTypeEnum.week,
    name: '7天'
  },
  {
    value: chargeTypeEnum.month,
    name: '1个月'
  },
  {
    value: chargeTypeEnum.quarter,
    name: '3个月'
  },
  {
    value: chargeTypeEnum.yearHalf,
    name: '6个月'
  },
  {
    value: chargeTypeEnum.year,
    name: '12个月'
  }
]

export const VIP_RENEWAL_STATUS = {
  yes: 1,
  no: 2
}

export const VIP_RENEWAL_LIST = [
  {
    label: '已续订',
    value: VIP_RENEWAL_STATUS.yes
  },
  {
    label: '未续订',
    value: VIP_RENEWAL_STATUS.no
  }
]

// 权益类型
export const rightsSettingsType = {
  // 1：云存储空间 2：视频 3：商品兑换折扣 4：视频时长购买折扣
  clound: 1,
  video: 2,
  goods: 3,
  videoTime: 4
}
export const memberSource = {
  // 1：会员 2：单个购买 3：赠送 4、礼包 5、邀请有礼 6、邀请有礼（被邀请） 7、订单兑换 8、抽奖 9、任务中心 10 makenow
  vip: 1,
  single: 2,
  presenter: 3,
  gift: 4,
  invite: 5,
  be_invite: 6,
  order_exchange: 7,
  lottery: 8,
  task: 9,
  makenow: 10
}
// 公告推送范围类型枚举
export const noticeRangeTypeEnum = {
  // 所有用户
  allUser: 1,
  // 部分用户
  someUser: 2,
  // 指定用户
  specifyUser: 3,
  // 标签用户
  tagUser: 4,
  // 标签人群组
  tagGroup: 5
}
// 公告通知类型枚举
export const noticePushTypeEnum = {
  // 仅Push
  push: 1,
  // 仅消息
  massage: 2,
  // Push+消息
  pushAndMsg: 3
}
// 公告平台类型枚举
export const noticePlatformTypeEnum = {
  // IOS
  ios: 0,
  // Android
  android: 1,
  // PC
  pc: 2,
  // H5
  h5: 4,
  // CP
  cp: 11,
  // Others
  others: 10000
}
// 公告平台类型筛选列表
export const NOTICE_PLATFORM_TYPE_LIST = [
  { label: 'IOS', value: noticePlatformTypeEnum.ios },
  { label: 'Android', value: noticePlatformTypeEnum.android },
  { label: 'PC', value: noticePlatformTypeEnum.pc },
  { label: 'H5', value: noticePlatformTypeEnum.h5 },
  { label: 'CP', value: noticePlatformTypeEnum.cp },
  { label: '其他', value: noticePlatformTypeEnum.others }
]
// 审核理由枚举
export const auditFailureEnum = {
  // 模型
  model: 1,
  // 提现
  deposit: 2,
  // 评论
  comment: 3,
  // 内容
  content: 4,
  // 打印文件
  printFile: 5,
  // 红人计划 审核不通过理由
  influencer: 6,
  // 活动下架删除原因
  contest: 7,
  // 星标模型移出
  curatedModel: 8,
  // 剔除预备原因
  curatedModelOutReason: 12,
  // 转换资格审核不通过
  convertOrder: 9,
  // 提现成功
  withdrawn: 10,
  // 商业模型表单审核不通过原因
  businessModel: 11
}
// 产品售卖状态
export const qrSaleStateEnum = {
  // 在售
  up: 1,
  // 停售
  down: 2
}
// 挤出机所在端枚举
export const extruderEnum = {
  // 近端
  near: 1,
  // 远端
  far: 2
}
// 喷嘴孔径枚举
export const nozzleApertureEnum = {
  // 0.4
  first: 1,
  // 0.6
  second: 2,
  // 标配1.0
  third: 3
}
// 打印速度枚举
export const printSpeedEnum = {
  // 普通
  normal: 1,
  // 高速
  speed: 2
}
// 耗材
export const materialTypeEnum = {
  // 1.PLA
  // 2.ABS
  // 3.树脂
  // 4.尼龙
  // 5.金属
  // 6.橡胶
  // 7.腊
  // 8.TPU
  // 9.PETG
  // 10.其它
  // 11.Wood
  // 12.碳质
  // 13.PCL
  // 14.Silk
  // 15.PA
  // 16.PC
  // 17.炭纤维
  // 18.Carbon Fiber X
  // 19.软胶
  // 20.仿金属材料
  // 二：光固化
  // 31.低气味刚性树脂
  // 32.可铸造首饰树脂
  // 33.标准刚性树脂+
  // 34.水洗树脂+
  // 35.生物基树脂
  // 36.高温压膜树脂

  pla: 1,
  abs: 2,
  nilong: 4,
  tpu: 8,
  petg: 9,
  wood: 11,
  // 碳质
  carbonaceous: 12,
  pcl: 13,
  silk: 14,
  pa: 15,
  pc: 16,
  // 碳纤维
  carbon: 17,
  carbonFiberX: 18,
  // 软胶
  softAdhesive: 19,
  // 仿金属材料
  imitationMetal: 20,

  // 低气味刚性树脂
  lowOdorRigidResin: 31,
  // 可铸造首饰树脂
  castableJewelryResin: 32,
  // 标准刚性树脂
  standardRigidResin: 33,
  // 水洗树脂
  waterWashedResin: 34,
  // 生物基树脂
  biobasedResin: 35,
  // 高温压膜树脂
  highTemperatureResin: 36
}

// 耗材列表
export const materialTypeList = [
  {
    label: 'PLA',
    value: materialTypeEnum.pla
  },
  {
    label: 'ABS',
    value: materialTypeEnum.abs
  },
  {
    label: '尼龙',
    value: materialTypeEnum.nilong
  },
  {
    label: 'TPU',
    value: materialTypeEnum.tpu
  },
  {
    label: 'PETG',
    value: materialTypeEnum.petg
  },
  {
    label: 'Wood',
    value: materialTypeEnum.wood
  },
  {
    label: '碳质',
    value: materialTypeEnum.carbonaceous
  },
  {
    label: 'PCL',
    value: materialTypeEnum.pcl
  },
  {
    label: 'Silk',
    value: materialTypeEnum.silk
  },
  {
    label: 'PA',
    value: materialTypeEnum.pa
  },
  {
    label: 'PC',
    value: materialTypeEnum.pc
  },
  {
    label: '炭纤维',
    value: materialTypeEnum.carbon
  },
  {
    label: 'Carbon Fiber X',
    value: materialTypeEnum.carbonFiberX
  },
  {
    label: '软胶',
    value: materialTypeEnum.softAdhesive
  },
  {
    label: '仿金属材料',
    value: materialTypeEnum.imitationMetal
  },
  {
    label: '低气味刚性树脂',
    value: materialTypeEnum.lowOdorRigidResin
  },
  {
    label: '可铸造首饰树脂',
    value: materialTypeEnum.castableJewelryResin
  },
  {
    label: '标准刚性树脂+',
    value: materialTypeEnum.standardRigidResin
  },
  {
    label: '水洗树脂+',
    value: materialTypeEnum.waterWashedResin
  },
  {
    label: '生物基树脂',
    value: materialTypeEnum.biobasedResin
  },
  {
    label: '高温压膜树脂',
    value: materialTypeEnum.highTemperatureResin
  }
]

// 产品标签状态
export const qrTagStateEnum = {
  // 新品
  new: 1,
  // 热销
  hot: 2,
  // 秒杀
  seckill: 3,
  // 特价
  specialOffer: 4,
  // 直降
  plummet: 5,
  // 爆款
  hot2: 6
}
// 模型创作来源
export const modelCreateOrigin = {
  // 原创
  original: 1,
  // 分享
  share: 2,
  // 二次创作
  secondary: 3
}
export const modelOriginalList = [
  {
    label: '原创模型',
    value: modelCreateOrigin.original
  },
  {
    label: '分享模型',
    value: modelCreateOrigin.share
  },
  {
    label: '二次创作模型',
    value: modelCreateOrigin.secondary
  }
]
// 评论身份枚举
export const commentIdentityEnum = {
  // 本账号
  owner: 1,
  // 机器人
  robot: 2
}
// 用户身份枚举
export const identityEnum = {
  all: 0,
  robot: 1,
  common: 2,
  official: 3
}

export const userIdentityMap = {
  [identityEnum.robot]: '机器人',
  [identityEnum.common]: '普通用户',
  [identityEnum.official]: '官方用户'
}
// 推荐状态
export const recommencStatusEnum = {
  normal: 1,
  recommend: 2
}
// 拍照建模状态枚举
export const photoModelStatusEnum = {
  // 处理中
  processing: 1,
  // 处理完成
  processed: 2,
  // 处理失败
  err: 3
}
// 服务端处理状态
export const serviceProcessStatusEnum = {
  // 建模中
  modeling: 1,
  // 建模完成
  succ: 2,
  // 建模失败
  err: 3,
  // 添加修模任务失败(重试)
  addErr: 4,
  // 添加修模任务成功
  addSucc: 5,
  // 修复成功
  repairSucc: 6,
  // 修复失败
  repairErr: 7,
  // 创建模型组成功
  createSucc: 8,
  // 创建模型组失败
  createErr: 9
}
// 产品分类 aggType
export const productClassEnum = {
  // 耗材
  consumable: 3,
  // 配件
  accessory: 4,
  accessory2: 5,
  // fdm打印机
  fdmPrinter: 1,
  // 光固化打印机
  dlpPrinter: 2,
  // 其他
  other: 6,
  // 激光雕刻
  lasterPrint: 7,
  // 创想云终端
  crealityTerminal: 8,
  // 耗材干燥盒
  dryBox: 9,
  // 软件类
  software: 10
}

// 意见反馈 表单入口枚举
export const FACEBOOK_OBJTYPE = {
  // 星球灯
  starLight: 1,
  // 3d照片
  pictures3D: 2,
  // 心愿单
  wishList: 3,
  // 激光雕刻
  laserEngraving: 4,
  // 挪车牌
  movePlate: 5,
  // 笔筒
  brushPot: 6,
  // 拍照建模
  photoModeling: 7,
  // 模型详情
  modelDetails: 8,
  // 帮助与反馈
  help: 9,
  // 其他
  other: 100
}

export const FACEBOOK_OBJTYPE_LIST = [
  {
    label: '星球灯',
    value: FACEBOOK_OBJTYPE.starLight
  },
  {
    label: '3d照片',
    value: FACEBOOK_OBJTYPE.pictures3D
  },
  {
    label: '心愿单',
    value: FACEBOOK_OBJTYPE.wishList
  },
  {
    label: '激光雕刻',
    value: FACEBOOK_OBJTYPE.laserEngraving
  },
  {
    label: '挪车牌',
    value: FACEBOOK_OBJTYPE.movePlate
  },
  {
    label: '笔筒',
    value: FACEBOOK_OBJTYPE.brushPot
  },
  {
    label: '拍照建模',
    value: FACEBOOK_OBJTYPE.photoModeling
  },
  {
    label: '模型详情',
    value: FACEBOOK_OBJTYPE.modelDetails
  },
  {
    label: '帮助与反馈',
    value: FACEBOOK_OBJTYPE.help
  },
  {
    label: '其他',
    value: FACEBOOK_OBJTYPE.other
  }
]

// 异步任务类型
export const asyncTastBicTypes = {
  // 酷维豆
  bean: 1,
  // 创想币
  cxb: 2,
  // 会员
  vip: 3,
  // 空间
  space: 4,
  // 模型组
  model: 5,
  // 模型侵权
  modelCopyright: 6,
  // 同步权益
  equity: 7,
  // 优惠券自动发放
  couponSendMsg: 8,
  // 优惠券发送push
  bizTypeSendEmail: 9,
  // 发邮件
  pushEmail: 10,
  // 生日礼包
  birthdayPack: 11,
  // 3mf
  model3mf: 12,
  // 专题
  collection: 13,
  // 帖子
  post: 14
}
// 异步任务类型 列表
export const asyncTastBicTypeList = [
  {
    label: '酷维豆',
    value: asyncTastBicTypes.bean
  },
  {
    label: '创想币',
    value: asyncTastBicTypes.cxb
  },
  {
    label: '会员',
    value: asyncTastBicTypes.vip
  },
  {
    label: '云存储空间',
    value: asyncTastBicTypes.space
  },
  {
    label: '模型组',
    value: asyncTastBicTypes.model
  },
  {
    label: '模型侵权处理',
    value: asyncTastBicTypes.modelCopyright
  },
  {
    label: '同步权益',
    value: asyncTastBicTypes.equity
  },
  {
    label: '优惠券自动发放',
    value: asyncTastBicTypes.couponSendMsg
  },
  {
    label: '优惠券发送push',
    value: asyncTastBicTypes.bizTypeSendEmail
  },
  {
    label: '发邮件',
    value: asyncTastBicTypes.pushEmail
  },
  {
    label: '生日礼包',
    value: asyncTastBicTypes.birthdayPack
  },
  {
    label: '3mf',
    value: asyncTastBicTypes.model3mf
  },
  {
    label: '专题',
    value: asyncTastBicTypes.collection
  },
  {
    label: '帖子',
    value: asyncTastBicTypes.post
  }
]
// 异步任务状态
export const taskExecType = {
  being: 2,
  suspend: 3,
  pass: 4,
  fail: 5
}
// 异步任务状态 列表
export const taskExecStatus = [
  {
    label: '处理中',
    value: taskExecType.being
  },
  {
    label: '成功',
    value: taskExecType.pass
  },
  {
    label: '失败',
    value: taskExecType.fail
  },
  {
    label: '中止',
    value: taskExecType.suspend
  }
]

// 打印方式
export const printType = {
  fdm: 1,
  resin: 2
}

// 扫码登录状态
export const QRCODE_STATUS = {
  // 等待扫码
  WAITING: 1,
  // 已经扫码
  ALREADY: 2,
  // 登录成功
  SUCCESS: 3,
  // 二维码过期
  FAILED: 4,
  // 用户取消登录
  CANCEL: 5,
  // 无权限
  NOACCESS: 6
}

// 用户权限状态
export const USER_AUTH_STATUS = {
  // 全部
  ALL: 0,
  // 启用
  ENABLED: 2,
  // 禁用
  DISABLE: 3
}

// 用户权限枚举

export const AUTH_USER = {
  // 内容举报评“0级”
  EXPLAIN: 1
}
// 用户权限解释及枚举
export const AUTH_EXPLAIN = [
  { label: '内容举报评“0级”', value: AUTH_USER.EXPLAIN }
]

// 用户审核白名单枚举
export const AUTH_WHITE_LIST_ENUM = {
  // 内容（帖子、文章）免审核
  CONTENT: 2,
  // 模型免审核
  MODEL: 3,
  // 内容（含打印文件）免审核
  PRINT: 4
}
// 用户审核白名单枚举
export const AUTH_WHITE_LIST = [
  { label: '内容（帖子、文章）免审核', value: AUTH_WHITE_LIST_ENUM.CONTENT },
  { label: '模型免审核', value: AUTH_WHITE_LIST_ENUM.MODEL },
  { label: '内容（含打印文件）免审核', value: AUTH_WHITE_LIST_ENUM.PRINT }
]
// 芯片版本枚举1-halot一代 2-halot二代 3-CBD一代
export const slugVerEnum = {
  halot1: 1,
  halot2: 2,
  cbd: 3
}
// 添加/移除vip专区类型
export const MEMBER_LEVEL = {
  // 移除
  REMOVE: 0,
  // 添加
  ADD: 2
}

// VIP类型
export const VIP_TYPE = {
  // 全部
  ALL: 0,
  // 会员
  VIP: 1,
  // 非VIP
  COMMON: 2
}
// 固件显示目标
export const firmwareTargetTypeEnum = {
  // 全部
  all: 1,
  // 指定用户
  userId: 2,
  // DN尾号推送
  dnPush: 3,
  // DN号推送
  dn: 4
}

// 是否强制升级
export const updatedStatus = {
  // 是
  yes: 1,
  // 否
  no: 2
}
// 兑换商品支付价格类型
export const goodsPayMethodEnum = {
  // 1：酷维豆 2：创想币 3美金
  kwd: 1,
  cxb: 2,
  money: 3
}
// 币种
export const currencyTypeEnum = {
  // 币种，1人民币 2港币 3美元
  renminbi: 1,
  gangbi: 2,
  meiyuan: 3
}
// java支付方式 0 微信 1 支付宝 2 ios内购 3 paypal 4 googlePay 5 stripe 6 payoneer
export const payWayEnum = {
  wx: 0,
  alipay: 1,
  ios: 2,
  paypal: 3,
  googlePay: 4,
  stripe: 5,
  payoneer: 6
}
// 会员购买-支付方式-枚举
export const member_payMethod = {
  // 酷维豆
  beans: 1,
  // 创想币
  coin: 2,
  // 微信
  wechat: 3,
  // 支付宝
  alipay: 4,
  // 苹果支付
  applepay: 5,
  // PayPal支付
  PayPal: 6,
  // 谷歌支付
  googlePay: 7,
  // 平台赠送
  send: 8,
  // 礼包兑换
  gift: 9,
  // 生日礼包
  birthdayPack: 12,
  // 抽奖
  lottery: 13,
  payoneer: 14,
  stripe: 15,
  // 购机礼包
  buyGift: 16,
  // 新人礼包
  newmanGift: 17,
  // 签到获取
  signInGift: 18
}
// golang
// 会员购买-支付方式-列表
export const member_payMethod_list = [
  // {
  //   name: '全部',
  //   id: ''
  // },
  {
    name: '微信',
    id: member_payMethod.wechat
  },
  {
    name: '支付宝',
    id: member_payMethod.alipay
  },
  {
    name: '苹果支付',
    id: member_payMethod.applepay
  },
  {
    name: 'Google Pay',
    id: member_payMethod.googlePay
  },
  {
    name: 'PayPal',
    id: member_payMethod.PayPal
  },
  {
    name: '平台赠送',
    id: member_payMethod.send
  },
  {
    name: '礼包兑换',
    id: member_payMethod.gift
  },
  {
    name: 'Payoneer',
    id: member_payMethod.payoneer
  },
  {
    name: 'Stripe',
    id: member_payMethod.stripe
  },
  {
    name: '生日礼包',
    id: member_payMethod.birthdayPack
  },
  {
    name: '抽奖获取',
    id: member_payMethod.lottery
  },
  {
    name: '购机礼包',
    id: member_payMethod.buyGift
  },
  {
    name: '新人礼包',
    id: member_payMethod.newmanGift
  },
  {
    name: '签到获取',
    id: member_payMethod.signInGift
  }
]
// 开户行枚举
export const bankIypeEnum = {
  // Paypal
  Paypal: 1,
  // 支付宝
  zhifubao: 2,
  wechat: 3,
  payoneer: 4
}

// 支付方式（到账方式）
export const paymentTypeEnum = {
  // 1 Paypal
  paypal: 1,
  // 2 支付宝
  aliPay: 2,
  // 3 微信
  weChat: 3,
  // 4 银行卡
  bankCard: 4,
  // 5 派安盈
  payoneer: 5
}

// 实拍字段  1-实拍 2-打印文件
export const realPhotoTypes = {
  // 1-实拍
  realPhoto: 1,
  // 2-打印文件
  relevance: 2
}

// 标签类型
export const tagTypeEnum = {
  // 1 内容
  content: 1,
  // 2 模型
  model: 2,
  // 2 用户
  user: 3,
  // 多色
  colors: 4
}

/**
 * 解析状态
 * @param {*} await 1. 待解析
 * @param {*} parsing 2. 解析中
 * @param {*} success 3. 解析成功
 * @param {*} fail 4. 解析失败
 */
export const parseState = {
  await: 1,
  parsing: 2,
  success: 3,
  fail: 4
}

export const envMap = {
  development: 1,
  production: 2,
  international: 3,
  pre: 4,
  preInt: 5
}

export const envList = [
  {
    label: '测试环境',
    value: envMap.development,
    key: 'development',
    hiddenEnv: ['international', 'production']
  },
  {
    label: '国内正式环境',
    value: envMap.production,
    key: 'production',
    hiddenEnv: []
  },
  {
    label: '海外正式环境',
    value: envMap.international,
    key: 'international',
    hiddenEnv: []
  },
  {
    label: '国内预发布环境',
    value: envMap.pre,
    key: 'pre',
    hiddenEnv: ['international', 'production']
  },
  {
    label: '海外预发布环境',
    value: envMap.preInt,
    key: 'preInt',
    hiddenEnv: ['international', 'production']
  }
]

// 专题列表图
export const imgType = {
  one: 'upload', // 上传封面图
  other: 'modelIds' // 模型封面图拼接
}

export const importStatus = {
  isImport: 1, // 导入专题
  isSelect: 2, // 选入专题
  noSelect: 3 // 不选入该专题
}

// 创想云云平台类型
export const CREALITY_CLOUD_PLATFORM_TYPE = {
  old: 'cxy-old',
  new: 'cxy-gen2'
}

// 创想云云平台分类列表
export const CREALITY_CLOUD_PLATFORM_LIST = [
  {
    label: '旧创想云',
    value: CREALITY_CLOUD_PLATFORM_TYPE.old
  },
  {
    label: '新创想云',
    value: CREALITY_CLOUD_PLATFORM_TYPE.new
  }
]

// 设备类型列表
export const deviceTypeList = [
  {
    label: 'FDM',
    value: printerSeriesType.fdm,
    children: []
  },
  {
    label: '光固化',
    value: printerSeriesType.access,
    children: []
  },
  {
    label: '耗材干燥盒',
    value: printerSeriesType.dryBox,
    children: []
  }
]

export const dryBoxType = {
  double: 2
}

export const dryBoxList = [
  {
    label: '双舱',
    value: dryBoxType.double
  }
]

// 内测机型状态枚举
export const BETA_PRINTER_STATUS = {
  all: 0, // 全部
  enabled: 1, // 启用
  closed: 2 // 已关闭
}

// 内测机型状态列表
export const BETA_PRINTER_STATUS_LIST = [
  {
    label: '全部',
    value: BETA_PRINTER_STATUS.all
  },
  {
    label: '启用',
    value: BETA_PRINTER_STATUS.enabled
  },
  {
    label: '已关闭',
    value: BETA_PRINTER_STATUS.closed
  }
]
